import { AfterContentChecked, AfterViewInit, Component, Inject, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AppConstants } from 'app/app.settings';
import { SupplierTaskDetail } from 'app/profile/models/suppliertasks.model';
import { I18nService } from 'app/shared/services/i18n.service';
import { AddressTaskWrapperComponent } from '../address-task-wrapper/address-task-wrapper.component';
import { BankTaskWrapperComponent } from '../bank-task-wrapper/bank-task-wrapper.component';
import { ContactTaskWrapperComponent } from '../contact-task-wrapper/contact-task-wrapper.component';
import { TaxTaskWrapperComponent } from '../tax-task-wrapper/tax-task-wrapper.component';
import { ContextVerbiage } from 'app/profile/models/supplier.model';
import { TaskStatus, TimeTrackTypes } from 'app/profile/models/onboarding.model';
import { SupplierTaskService } from 'app/profile/services/supplier-task.service';
import { Store } from '@ngrx/store';
import { HostListener } from '@angular/core';
import { OnboardingState } from 'app/profile/store/state/onboarding.state';
import * as MasterDataSelectors from "../../../store/selectors/masterdata.selector";
import { FileViewerComponent } from 'app/shared/components/file-viewer/file-viewer.component';
import { getEnvironmentFromClientUrl, isNullOrUndefined } from 'app/shared/utils/utils';
import { Observable } from 'rxjs';
import { InsuranceTaskWrapperComponent } from '../insurance-task-wrapper/insurance-task-wrapper.component';
import { DetailTaskWrapperComponent } from '../detail-task-wrapper/detail-task-wrapper.component';
import { DomainTaskWrapperComponent } from '../domain-task-wrapper/domain-task-wrapper.component';
import { MsmeTaskWrapperComponent } from '../msme-task-wrapper/msme-task-wrapper.component';
import { BaseComponent } from '../../base.component';
import { Router } from '@angular/router';
import { SupplierState } from 'app/profile/store/state/supplierstate.state';

@Component({
  selector: 'app-task-side-panel',
  templateUrl: './task-side-panel.component.html',
  styleUrls: ['./task-side-panel.component.scss']
})
export class TaskSidePanelComponent extends BaseComponent implements OnInit, AfterContentChecked {
  taskDetail: SupplierTaskDetail;
  onboardingType: string;
  enableWebComponent = true;
  saveBtnLabel: string = 'Save';
  submitBtnLabel: string = 'Submit';
  cancelBtnLabel: string = 'Cancel';
  authTokenPath;
  contextVerbiage: ContextVerbiage;
  
  @ViewChild('detailsTask', { static: false }) detailsTaskComponent: DetailTaskWrapperComponent;
  @ViewChild('addressTask', { static: false }) addressTaskComponent: AddressTaskWrapperComponent;
  @ViewChild('contactTask', { static: false }) contactTaskComponent: ContactTaskWrapperComponent;
  @ViewChild('bankTask', { static: false }) bankTaskComponent: BankTaskWrapperComponent;
  @ViewChild('taxTask', { static: false }) taxTaskComponent: TaxTaskWrapperComponent;
  @ViewChild('diversityTask', { static: false }) diversityTaskComponent: TaxTaskWrapperComponent;
  @ViewChild('insuranceTask', { static: false }) insuranceTaskComponent: InsuranceTaskWrapperComponent;
  @ViewChild('domainTask', { static: false }) domainTaskComponent: DomainTaskWrapperComponent;
  @ViewChild('msmeTask', { static: false }) msmeTaskComponent: MsmeTaskWrapperComponent;
  public language: string;
  public env: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {task:SupplierTaskDetail, onboardingType: string},
    public dialogRef: MatDialogRef<TaskSidePanelComponent>,
    public translate: I18nService,
    public appConstants: AppConstants,
    private onboardingStore: Store<OnboardingState>,
    private store: Store<SupplierState>,
    private taskService: SupplierTaskService,
    protected matDialog: MatDialog,
    private router: Router
  ) {
    super();
    this.taskDetail = data?.task;
    this.onboardingType = data?.onboardingType;
    console.log(this.onboardingType);
    this.enableWebComponent = this.taskDetail && !this.taskDetail.isProfileTask;
    this.authTokenPath = this.appConstants.openid.id ? this.appConstants.openid.id + ':token' : 'supplier-profile:token';
    this.language = localStorage.getItem('Profile-Culture') ? localStorage.getItem('Profile-Culture').replace(/"/g, "") : 'en-US';
    this.env = getEnvironmentFromClientUrl(window.location.href);
  }

  ngOnDestroy(): void {
    if (this.taskDetail.taskStatus==TaskStatus.New || this.taskDetail.taskStatus==TaskStatus.Rejected)
    {
      this.endTimeTrack().subscribe(
        (response) => {
          // Handle the response from the server
          console.log('End Time track started:', response);
        },
        (error) => {
          // Handle any errors that occurred during the request
          console.error('Failed to End time track:', error);
        }
      );
    }
  }
  ngOnInit(): void {
    this.onboardingStore.select(MasterDataSelectors.SelectContextVerbiage).subscribe(contextVerbiage => this.contextVerbiage = contextVerbiage);
    this.PrimaryContactDocument(this.store, this.router, this.taskDetail?.supplierCode, false);
  }

  ngAfterContentChecked(): void {
      
      // Close Task if PCF or MFA Not Available
      if((!isNullOrUndefined(this.onboardingType) && ['nameortinchange','entityextension'].includes(this.onboardingType?.toLowerCase()) && ((!this.isPCFUploaded && !this.showMFADialog) || this.isPCFValidationInReview)))
      {
        this.close(false);
      }
  }

  close(refresh?: boolean) {
    document
      .getElementsByClassName('animate__animated')[0]
      .classList.add('animate__slideOutRight');
    setTimeout(() => {
      this.dialogRef.close(refresh);
    }, 1000);
  }

  endTimeTrack(): Observable<any> { 
    let timeTrackType = TimeTrackTypes.EndTime;
    return this.taskService.postTaskTimeTrack(this.taskDetail.portalTaskID.toString(), this.taskDetail.supplierCode, this.taskDetail.subTaskType, timeTrackType);
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: BeforeUnloadEvent) {
    event.preventDefault();
    event.returnValue = '';
    if (this.taskDetail.taskStatus==TaskStatus.New || this.taskDetail.taskStatus==TaskStatus.Rejected)
    {
      this.endTimeTrack().subscribe(
        (response) => {
          return true;
        },
        (error) => {
          return true;
        }
      );
    }
    return true;
  }

  submit(isPartialSave?: boolean) {
    switch (this.taskDetail?.subTaskType) {
      case "Details": {
        this.detailsTaskComponent?.onSubmit();
        break;
      }
      case "Address": {
        this.addressTaskComponent?.onSubmit();
        break;
      }
      case "AddressList": {
        this.addressTaskComponent?.onSubmit();
        break;
      }
      case "Contacts": {
        this.contactTaskComponent?.submit();
        break;
      }
      case "Bank": {
        this.bankTaskComponent?.onSubmit(isPartialSave);
        break;
      }
      case "BankList": {
        this.bankTaskComponent?.onSubmit(isPartialSave);
        break;
      }
      case "Tax": {
        this.taxTaskComponent?.onSubmit();
        break;
      }
      case "TaxList": {
        this.taxTaskComponent?.onSubmit();
        break;
      }
      case "Diversity": {
        this.diversityTaskComponent?.onSubmit();
        break;
      }
      case "Insurance": {
        this.insuranceTaskComponent?.onSubmit();
      }
      case "Domain": {
        this.domainTaskComponent?.onSubmit();
      }
      case "MSME": {
      this.msmeTaskComponent?.onSubmit();
      }
    }
  }

  onSave(event) {
    if (event) this.close(true);
  }

  showDocumentHelpIcon() {
    var task = this.taskDetail?.subTaskType.toLowerCase();
    if (["codeofconduct", "esigndocument", "noponopaypolicy", "privacypolicy", "uploaddocument"].includes(task))
      return this.contextVerbiage && this.contextVerbiage?.document?.userManual;;
    if (this.taskDetail?.subTaskType == "Contacts") task = "contact";
    if (!["Address", "AddressList", "Contacts", "Bank", "Tax", "TaxList", "Diversity", "EHS"].includes(this.taskDetail?.subTaskType)) return false;
    return !!this.contextVerbiage && this.contextVerbiage[task]?.userManual;
  }

  showManual() {
    var task = this.taskDetail?.subTaskType.toLowerCase();
    if (this.taskDetail?.subTaskType == "Contacts") task = "contact";
    if (["codeofconduct", "esigndocument", "noponopaypolicy", "privacypolicy", "uploaddocument"].includes(task))
      task = "document";
    let manual = this.contextVerbiage[task]?.userManual;
    this.matDialog.open(FileViewerComponent, {
      // panelClass: ['sidepanel', 'animate__animated', 'animate__slideInRight'],
      width: '1200px',
      data: {
        fileName: manual.fileName,
        fileId: manual.fileId,
        fileVersion: manual.fileVersion
      }
    });
  }
}
